export class ListSavedQueriesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListSavedQueriesFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortSavedQueryBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSavedQueriesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
